import { render } from "./GasPrice.vue?vue&type=template&id=67d001a9&scoped=true"
import script from "./GasPrice.vue?vue&type=script&lang=js"
export * from "./GasPrice.vue?vue&type=script&lang=js"

import "./GasPrice.vue?vue&type=style&index=0&id=67d001a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d001a9"]])

export default __exports__